import react from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./_Base.css";
import { DeleteEquipments, ShowEquipment } from "../../../api/api";
import { useContext } from "react";
import { Context } from "../../../context/Context";
import WarningAlert from "../../sweeAlerts/WarningAlert";
const DimmerShortcut = ({ equipment_id, equipment_name }) => {
  const navigate = useNavigate();
  const { room_id: roomId } = useParams();
  const {
    setSelectedEquipment,
    setRoomEquipments,
    roomEquipments,
    authUser,
    setIsLoading,
    equipments,
    equipmentButtons,
    setEquipments,
    selectedEquipment,
  } = useContext(Context);

  const handleClick = () => {
    // setIsLoading(true);
    // ShowEquipment({
    //   equipment_id,
    // })
    //   .then(({ data }) => {
    //     setSelectedEquipment({
    //       id: data.equipment.id,
    //       type: data.equipment.type,
    //     });
    //     if (data.equipment?.buttons.length) {
    //       navigate(
    //         "/room/dimmer/" +
    //           roomId +
    //           "/" +
    //           data.equipment.id +
    //           "/" +
    //           data.equipment.type
    //       );
    //     } else {
    //       navigate(
    //         "/room/select-device/" +
    //           roomId +
    //           "/" +
    //           data.equipment.id +
    //           "/" +
    //           data.equipment.type
    //       );
    //     }
    //     setIsLoading(false);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    let equipment = equipments.find((eq) => eq.id == equipment_id);
    let equipment_buttons = equipmentButtons.filter(
      (eq_btn) => eq_btn.equipment_id == equipment_id
    );
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    // if (equipment_buttons.length) {
    navigate(
      "/room/dimmer/" +
        roomId +
        "/" +
        equipment.equipment_id +
        "/" +
        equipment.equipment.type
    );
    // } else {
    //   navigate(
    //     "/room/select-device/" +
    //       roomId +
    //       "/" +
    //       equipment.equipment_id +
    //       "/" +
    //       equipment.equipment.type
    //   );
    // }
  };
  const handleRemoveEquipment = (equipment_id) => {
    WarningAlert(
      "آیا از حذف این تجهیز اطمینان دارید؟",
      "",
      "تایید",
      "انصراف"
    ).then(function (result) {
      if (result.value) {
        setIsLoading(true);
        DeleteEquipments({
          equipment_id,
        }).then(({ data }) => {
          // setEquipments(
          //   (prevEquipments) =>
          //     prevEquipments.filter((item) => item.id !== equipment_id) // Remove the equipment from the equipments list
          // );
          setEquipments(
            (prevEquipments) =>
              prevEquipments.filter((item) => item.id !== equipment_id) // Remove the equipment from the equipments list
          );
          setIsLoading(false);
        });
      }
    });
  };
  return (
    <div
      className={
        selectedEquipment.id == equipment_id
          ? "card h-100 device active-equipment"
          : "card h-100 device"
      }
      onClick={handleClick}
    >
      <img
        className={authUser.is_admin ? "card-img-top" : "card-img-top mt-3"}
        src="/assets/img/app-icons/Ao1.png"
        alt="Card image cap"
      />
      <div className="card-body p-0" style={{color: 'black'}}>
        <p className={selectedEquipment.id == equipment_id ? 'card-title text-center mb-3 text-success-app' : 'card-title text-center mb-3 equipment-name'}>
          {/* {selectedEquipment.id == equipment_id ? equipment_name : ""} */}
          {equipment_name}
        </p>
      </div>
    </div>
  );
};

export default DimmerShortcut;
